import React, { useEffect, useState } from "react";
// import EnergyDetails from "../../../../../../assets/images/EnergyDetails.png";
import EnergyDetails from "../../../../../../assets/images/industry-images/EnergyDetails.png?url";
import EnergyDetails1 from "../../../../../../assets/images/industry-images/EnergyDetails1.png?url";
import EnergyDetails2 from "../../../../../../assets/images/industry-images/EnergyDetails2.png?url";
import EnergyStorageMain from "../../../../../../assets/images/industry-images/EnergyStorageMain.png?url";
import EnergyStorageMain1 from "../../../../../../assets/images/industry-images/EnergyStorageMain1.png?url";
import EnergyStorageMain2 from "../../../../../../assets/images/industry-images/EnergyStorageMain2.png?url";
import EnergyStorageMain3 from "../../../../../../assets/images/industry-images/EnergyStorageMain3.png?url";
import SolarEnergyMain from "../../../../../../assets/images/industry-images/SolarEnergyMain.png?url";
import SolarEnergyMain1 from "../../../../../../assets/images/industry-images/SolarEnergyMain1.png?url";
import SolarEnergyMain2 from "../../../../../../assets/images/industry-images/SolarEnergyMain2.png?url";
import SolarEnergyMain3 from "../../../../../../assets/images/industry-images/SolarEnergyMain3.png?url";
import ElectricTransportMain from "../../../../../../assets/images/industry-images/ElectricTransportMain.png?url";
import ElectricTransportMain1 from "../../../../../../assets/images/industry-images/ElectricTransportMain1.png?url";
import ElectricTransportMain2 from "../../../../../../assets/images/industry-images/ElectricTransportMain2.png?url";
import ElectricTransportMain3 from "../../../../../../assets/images/industry-images/ElectricTransportMain3.png?url";
import GridMain from "../../../../../../assets/images/industry-images/GridMain.png?url";
import GridMain1 from "../../../../../../assets/images/industry-images/GridMain1.png?url";
import GridMain2 from "../../../../../../assets/images/industry-images/GridMain2.png?url";
import GridMain3 from "../../../../../../assets/images/industry-images/GridMain3.png?url";
import BuildMain from "../../../../../../assets/images/industry-images/BuildMain.png?url";
import BuildMain1 from "../../../../../../assets/images/industry-images/BuildMain1.png?url";
import BuildMain2 from "../../../../../../assets/images/industry-images/BuildMain2.png?url";
import BuildMain3 from "../../../../../../assets/images/industry-images/BuildMain3.png?url";
import OffShoreWindMain from "../../../../../../assets/images/industry-images/OffShoreWindMain.png?url";
import OffShoreWindMain1 from "../../../../../../assets/images/industry-images/OffShoreWindMain1.png?url";
import OffShoreWindMain2 from "../../../../../../assets/images/industry-images/OffShoreWindMain2.png?url";
import OffShoreWindMain3 from "../../../../../../assets/images/industry-images/OffShoreWindMain3.png?url";
import HydrogenMain from "../../../../../../assets/images/industry-images/HydrogenMain.png?url";
import HydrogenMain1 from "../../../../../../assets/images/industry-images/HydrogenMain1.png?url";
import HydrogenMain2 from "../../../../../../assets/images/industry-images/HydrogenMain2.png?url";
import HydrogenMain3 from "../../../../../../assets/images/industry-images/HydrogenMain3.png?url";
import HydroPowerMain from "../../../../../../assets/images/industry-images/HydroPowerMain.png?url";
import HydroPowerMain1 from "../../../../../../assets/images/industry-images/HydroPowerMain1.png?url";
import HydroPowerMain2 from "../../../../../../assets/images/industry-images/HydroPowerMain2.png?url";
import HydroPowerMain3 from "../../../../../../assets/images/industry-images/HydroPowerMain3.png?url";
import MarinMain from "../../../../../../assets/images/industry-images/MarinMain.png?url";
import MarinMain1 from "../../../../../../assets/images/industry-images/MarinMain1.png?url";
import MarinMain2 from "../../../../../../assets/images/industry-images/MarinMain2.png?url";
import MarinMain3 from "../../../../../../assets/images/industry-images/MarinMain3.png?url";
import NuclearMain from "../../../../../../assets/images/industry-images/NuclearMain.png?url";
import NuclearMain1 from "../../../../../../assets/images/industry-images/NuclearMain1.png?url";
import NuclearMain2 from "../../../../../../assets/images/industry-images/NuclearMain2.png?url";
import NuclearMain3 from "../../../../../../assets/images/industry-images/NuclearMain3.png?url";
import OilAndGasMain from "../../../../../../assets/images/industry-images/OilAndGasMain.png?url";
import OilAndGasMain1 from "../../../../../../assets/images/industry-images/OilAndGasMain1.png?url";
import OilAndGasMain2 from "../../../../../../assets/images/industry-images/OilAndGasMain2.png?url";
import OilAndGasMain3 from "../../../../../../assets/images/industry-images/OilAndGasMain3.png?url";
import RefineMain from "../../../../../../assets/images/industry-images/RefiningMain.png?url";
import RefineMain1 from "../../../../../../assets/images/industry-images/RefiningMain1.png?url";
import RefineMain2 from "../../../../../../assets/images/industry-images/RefiningMain2.png?url";
import RefineMain3 from "../../../../../../assets/images/industry-images/RefiningMain3.png?url";
import GeoThermal from "../../../../../../assets/images/industry-images/GeoThermal.png?url";
import GeoThermal1 from "../../../../../../assets/images/industry-images/GeoThermal1.png?url";
import GeoThermal2 from "../../../../../../assets/images/industry-images/GeoThermal2.png?url";
import GeoThermal3 from "../../../../../../assets/images/industry-images/GeoThermal3.png?url";
import CyberSecurity from "../../../../../../assets/images/industry-images/CyberSecurity.png?url";
import CyberSecurity1 from "../../../../../../assets/images/industry-images/CyberSecurity1.png?url";
import CyberSecurity2 from "../../../../../../assets/images/industry-images/CyberSecurity2.png?url";
import CyberSecurity3 from "../../../../../../assets/images/industry-images/CyberSecurity3.png?url";
import CriticalMain from "../../../../../../assets/images/industry-images/CriticalMain.png?url";
import CriticalMain1 from "../../../../../../assets/images/industry-images/CriticalMain1.png?url";
import CriticalMain2 from "../../../../../../assets/images/industry-images/CriticalMain2.png?url";
import CriticalMain3 from "../../../../../../assets/images/industry-images/CriticalMain3.png?url";
import CoalMain from "../../../../../../assets/images/industry-images/CoalMain.png?url";
import CoalMain1 from "../../../../../../assets/images/industry-images/CoalMain1.png?url";
import CoalMain2 from "../../../../../../assets/images/industry-images/CoalMain2.png?url";
import CoalMain3 from "../../../../../../assets/images/industry-images/CoalMain3.png?url";
import CCUSMain from "../../../../../../assets/images/industry-images/CCUSMain.png?url";
import CCUSMain1 from "../../../../../../assets/images/industry-images/CCUSMain1.png?url";
import CCUSMain2 from "../../../../../../assets/images/industry-images/CCUSMain2.png?url";
import CCUSMain3 from "../../../../../../assets/images/industry-images/CCUSMain3.png?url";
import BioEnergy from "../../../../../../assets/images/industry-images/BioEnergy.png?url";
import BioEnergy1 from "../../../../../../assets/images/industry-images/BioEnergy1.png?url";
import BioEnergy2 from "../../../../../../assets/images/industry-images/BioEnergy2.png?url";
import BioEnergy3 from "../../../../../../assets/images/industry-images/BioEnergy3.png?url";
import AiMain from "../../../../../../assets/images/industry-images/AiMain.png?url";
import AiMain1 from "../../../../../../assets/images/industry-images/AiMain1.png?url";
import AiMain2 from "../../../../../../assets/images/industry-images/AiMain2.png?url";
import AiMain3 from "../../../../../../assets/images/industry-images/AiMain3.png?url";

import { Row, Col, Button, Tooltip, Card, Grid } from "antd";
import SVGIcon from "../../../../../../utils/SVGIcon";
import BreadcrumbComponent from "../../../../CommonComponent/BreadcrumbComponent";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addRemoveJob, getCriticalCareer } from "../../Utils/slice";
import { AppDispatch, RootState } from "../../../../../../store/app";
import {
  formatGlobalPrice,
  Notification,
} from "../../../../../../config/Global";
import onShoreWindEnergy from "../../../../../../assets/helper/onShoreWindEnergy.json";
import ElectricTransportation from "../../../../../../assets/helper/Electric Transportation.json";
import EnergyEffecientBuilding from "../../../../../../assets/helper/Energy Efficient Buildings.json";
import EnergyStorageSystem from "../../../../../../assets/helper/Energy Storage Systems (ESS).json";
import GridModernTransmission from "../../../../../../assets/helper/Grid Modernization & Transmission.json";
import SolarEnergy from "../../../../../../assets/helper/Solar Energy.json";
import OffShoreWindEnergy from "../../../../../../assets/helper/OffShoreWind.json";
import HydrogenEnergy from "../../../../../../assets/helper/Hydrogen Energy.json";
import HydroPowerEnergy from "../../../../../../assets/helper/Hydropower Energy.json";
import MarinEnergy from "../../../../../../assets/helper/Marine Energy.json";
import CriticalEnergy from "../../../../../../assets/helper/Critical Minerals_ The Building Blocks of the Clean Energy Future.json";
import AiInEnergySystem from "../../../../../../assets/helper/AI in Energy Systems.json";
import Bioenergy from "../../../../../../assets/helper/Bioenergy.json";
import ccus from "../../../../../../assets/helper/Carbon Capture, Utilization & Storage (CCUS).json";
import CoalAndNaturalGas from "../../../../../../assets/helper/Coal and Natural Gas Extraction.json";
import CyberSecurityEnergy from "../../../../../../assets/helper/Cybersecurity for Energy Systems.json";
import GeoThermalEnergy from "../../../../../../assets/helper/Geothermal Energy.json";
import NuclearEnergy from "../../../../../../assets/helper/Nuclear Energy.json";
import OilAndGas from "../../../../../../assets/helper/Oil & Gas Operations.json";
import RefineTransport from "../../../../../../assets/helper/Refining, Transport, and Industrial Applications.json";


import { CONSTANT } from "../../../../../../config/Constant";
const stripHtml = (html: string) => {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const EnergyIndustriesDetails = () => {
  // const location = useLocation();
  var { id }: any = useParams();
  id = atob(id);
  const dispatch: AppDispatch = useDispatch();
  const careerListData = useSelector(
    (state: RootState) => state.WEBPROFILE.criticalCareerList
  );
  const [loading, setLoading] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const navigate = useNavigate();

  const industryDataMap: { [key: string]: any } = {
    "1": SolarEnergy,
    "3": OffShoreWindEnergy,
    "8": ElectricTransportation,
    "10": onShoreWindEnergy,
    "19": AiInEnergySystem,
    "20": Bioenergy,
    "21": ccus,
    "22": CoalAndNaturalGas,
    "23": CriticalEnergy,
    "24": CyberSecurityEnergy,
    "25": EnergyEffecientBuilding,
    "26": EnergyStorageSystem,
    "27": GeoThermalEnergy,
    "28": GridModernTransmission,
    "29": HydrogenEnergy,
    "30": HydroPowerEnergy,
    "31": MarinEnergy,
    "32": NuclearEnergy,
    "33": OilAndGas,
    "34": RefineTransport,
  };

  const data = industryDataMap[id] || onShoreWindEnergy;

  useEffect(() => {
    fetchCriticalCareers();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchCriticalCareers = async () => {
    // console.log("id", id);
    if (id) {
      setLoading(true);
      try {
        await dispatch(getCriticalCareer(id));
      } catch (error) {
        // handle error if needed
      } finally {
        setLoading(false);
      }
    }
  };

  const SaveAndRemoveFromJobListProcess = (career_id: any, status: number) => {
    const requestData = {
      career_id: career_id,
      add: status,
    };
    setLoading(true);
    dispatch(addRemoveJob(requestData))
      .then((data: any) => {
        setLoading(false);
        fetchCriticalCareers();
        Notification.success({
          message: "You have successfully saved the career.",
        });
      })
      .catch((e: any) => {
        setLoading(false);
        fetchCriticalCareers();
      });
  };

  const imageMap: { [key: string]: string } = {
    "EnergyStorageMain.png": EnergyStorageMain,
    "EnergyStorageMain1.png": EnergyStorageMain1,
    "EnergyStorageMain2.png": EnergyStorageMain2,
    "EnergyStorageMain3.png": EnergyStorageMain3,
    "SolarEnergyMain.png": SolarEnergyMain,
    "SolarEnergyMain1.png": SolarEnergyMain1,
    "SolarEnergyMain2.png": SolarEnergyMain2,
    "SolarEnergyMain3.png": SolarEnergyMain3,
    "EnergyDetails.svg": EnergyDetails,
    "EnergyDetails1.png": EnergyDetails1,
    "EnergyDetails2.png": EnergyDetails2,
    "ElectricTransportMain.png": ElectricTransportMain,
    "ElectricTransportMain1.png": ElectricTransportMain1,
    "ElectricTransportMain2.png": ElectricTransportMain2,
    "ElectricTransportMain3.png": ElectricTransportMain3,
    "GridMain.png": GridMain,
    "GridMain1.png": GridMain1,
    "GridMain2.png": GridMain2,
    "GridMain3.png": GridMain3,
    "BuildMain.png": BuildMain,
    "BuildMain1.png": BuildMain1,
    "BuildMain2.png": BuildMain2,
    "BuildMain3.png": BuildMain3,
    "OffShoreWindMain.png": OffShoreWindMain,
    "OffShoreWindMain1.png": OffShoreWindMain1,
    "OffShoreWindMain2.png": OffShoreWindMain2,
    "OffShoreWindMain3.png": OffShoreWindMain3,
    "HydrogenMain.png": HydrogenMain,
    "HydrogenMain1.png": HydrogenMain1,
    "HydrogenMain2.png": HydrogenMain2,
    "HydrogenMain3.png": HydrogenMain3,
    "HydroPowerMain.png": HydroPowerMain,
    "HydroPowerMain1.png": HydroPowerMain1,
    "HydroPowerMain2.png": HydroPowerMain2,
    "HydroPowerMain3.png": HydroPowerMain3,
    "MarinMain.png": MarinMain,
    "MarinMain1.png": MarinMain1,
    "MarinMain2.png": MarinMain2,
    "MarinMain3.png": MarinMain3,
    "NuclearMain.png": NuclearMain,
    "NuclearMain1.png": NuclearMain1,
    "NuclearMain2.png": NuclearMain2,
    "NuclearMain3.png": NuclearMain3,
    "OilAndGasMain.png": OilAndGasMain,
    "OilAndGasMain1.png": OilAndGasMain1,
    "OilAndGasMain2.png": OilAndGasMain2,
    "OilAndGasMain3.png": OilAndGasMain3,
    "RefineMain.png": RefineMain,
    "RefineMain1.png": RefineMain1,
    "RefineMain2.png": RefineMain2,
    "RefineMain3.png": RefineMain3,
    "GeoThermal.png": GeoThermal,
    "GeoThermal1.png": GeoThermal1,
    "GeoThermal2.png": GeoThermal2,
    "GeoThermal3.png": GeoThermal3,
    "CyberSecurity.png": CyberSecurity,
    "CyberSecurity1.png": CyberSecurity1,
    "CyberSecurity2.png": CyberSecurity2,
    "CyberSecurity3.png": CyberSecurity3,
    "CriticalMain.png": CriticalMain,
    "CriticalMain1.png": CriticalMain1,
    "CriticalMain2.png": CriticalMain2,
    "CriticalMain3.png": CriticalMain3,
    "CoalMain.png": CoalMain,
    "CoalMain1.png": CoalMain1,
    "CoalMain2.png": CoalMain2,
    "CoalMain3.png": CoalMain3,
    "CCUSMain.png": CCUSMain,
    "CCUSMain1.png": CCUSMain1,
    "CCUSMain2.png": CCUSMain2,
    "CCUSMain3.png": CCUSMain3,
    "BioEnergy.png": BioEnergy,
    "BioEnergy1.png": BioEnergy1,
    "BioEnergy2.png": BioEnergy2,
    "BioEnergy3.png": BioEnergy3,
    "AiMain.png": AiMain,
    "AiMain1.png": AiMain1,
    "AiMain2.png": AiMain2,
    "AiMain3.png": AiMain3,
  };



  const breadcrumbItems = [
    {
      name: "Industry Awareness Hub",
      link: "/energy-industries",
    },
    { name: data?.pageTitle || "Comming Soon" },
  ];


  const appendUrl = (url: string) => {
    // console.log("url", url+'--');
    if (url == '')
      return navigate('#');
    else {
      window.open(CONSTANT.THINKIFIC_URL + url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className="energy-industry-details-page"
      style={{ backgroundColor: isMobile ? "#fff" : "#f5f5f5" }}
    >
      <div
        className="breadcrumb"
        style={{
          marginLeft: isMobile ? 25 : 0,
        }}
      >
        <BreadcrumbComponent key={1} items={breadcrumbItems} />
      </div>

      <div className="eid-hero-card">
        <h1 className="eid-title">{data.title}</h1>
        <div className="eid-desc">{data.description}</div>
        <img
          className="eid-hero-img"
          src={
            data.heroImage && imageMap[data.heroImage]
              ? imageMap[data.heroImage]
              : EnergyDetails
          }
          alt="Onshore Wind"
        />
        <Row gutter={[24, 16]} style={{ marginTop: 12 }}>
          {data.buttons &&
            data.buttons.map((btn: any, idx: number) => (
              <Col xs={24} md={12} key={idx}>
                <Button
                  htmlType="button"
                  onClick={() => {
                    btn?.think ? appendUrl(btn.link) : navigate(btn?.link);
                  }}
                  className={'common_button green_border_common_btn ' + (
                    btn.type === "filled"
                      ? " common_fill_button "
                      : "")
                  }
                  style={{ width: "100%" }}
                >
                  {btn.label}
                </Button>
              </Col>
            ))}
        </Row>
        <h2 style={{ marginTop: 40 }} className="eid-section-title">
          {/*{data.industryOverview.title}*/}
        </h2>
        <Row className="eid-industry101-row">
          <Col xs={24} className="eid-industry101-col-left">
            <img
              className="eid-industry101-main-img"
              src={
                data.industryOverview.mainImage &&
                  imageMap[data.industryOverview.mainImage]
                  ? imageMap[data.industryOverview.mainImage]
                  : EnergyDetails
              }
              alt="Onshore Wind"
            />
          </Col>
          <Col xs={24} className="eid-industry101-col-right">
            <h3 className="eid-industry101-title">
              {data.industryOverview.sections[0].subtitle}
            </h3>
            {data.industryOverview.sections[0].content.map(
              (p: string, idx: number) => (
                <p className="eid-industry101-desc" key={idx}>
                  {p}
                </p>
              )
            )}
          </Col>
        </Row>
        <Row className="eid-industry101-row" style={{ gap: 30 }}>
          <Col
            xs={24}
            className="eid-industry101-col-right"
            style={{ paddingLeft: 15, paddingRight: 15 }}
          >
            {(() => {
              const section1 =
                data.industryOverview.sections1 ||
                data.industryOverview.section1;
              if (!section1) return null;
              return (
                <>
                  {section1?.title && <h4 className="eid-industry101-process-title">
                    {section1.title}
                  </h4>}
                  {section1?.subTitle && <p className="eid-industry101-process-desc">
                    {section1.subTitle}
                  </p>}
                  {section1?.subTitle1 && <p
                    className="eid-industry101-process-desc"
                    style={{ marginBottom: 0 }}
                  >
                    {section1.subTitle1}
                  </p>}
                  <ul className="eid-industry101-process-list">
                    {Array.isArray(section1.process) &&
                      section1.process.map((step: any, idx: number) => (
                        <li className="eid-industry101-process-item" key={idx}>

                          <span>
                            <strong className="eid-green-title">
                              <span
                                className="eid-industry101-process-icon eid-green-icon"
                                dangerouslySetInnerHTML={{
                                  __html: step.icon || "",
                                }}
                              />
                              {step.title}
                            </strong>
                            <br />
                            <div className="eid-green-desc" dangerouslySetInnerHTML={{ __html: step.description }}></div>
                          </span>
                        </li>
                      ))}
                  </ul>

                  {Array.isArray(section1.content) && section1.content.length > 0 &&
                    <div className="eid-green-content-desc">
                      {
                        section1.content.map((step: string, idx: number) => <div dangerouslySetInnerHTML={{ __html: step }}></div>)
                      }
                    </div>
                  }
                  {section1?.subTitle2 && <p
                    className="eid-industry101-process-desc"
                    style={{ marginTop: 20 }}
                  >
                    {section1.subTitle2}
                  </p>}
                </>
              );
            })()}

            {(() => {
              const section2 =
                data.industryOverview.sections2 ||
                data.industryOverview.section2;
              if (!section2) return null;
              return (
                <>
                  {section2.title && <h4 className="eid-industry101-process-title" style={{marginTop: '1rem'}}>
                    {section2.title}
                  </h4>}
                  {section2.subTitle && <p className="eid-industry101-process-desc">
                    {section2.subTitle}
                  </p>}
                  {Array.isArray(section2.content) &&
                    <div className="eid-green-content-desc">
                      {
                        section2.content.map((step: string, idx: number) => <div dangerouslySetInnerHTML={{ __html: step }}></div>)
                      }
                    </div>
                  }
                  {/* {Array.isArray(section2.content) &&
                    section2.content.map((step: string, idx: number) => (
                      <li className="eid-industry101-process-item" key={idx}>
                        <p className="eid-green-content-desc">{step}</p>
                      </li>
                    ))} */}
                  {section2?.subTitle2 && <p
                    className="eid-industry101-process-desc"
                    style={{ marginTop: 20 }}
                  >
                    {section2.subTitle2}
                  </p>}
                </>
              );
            })()}
          </Col>
          <Col xs={24} className="eid-industry101-col-left">
            <img
              className="eid-industry101-main-img"
              src={
                data.industryOverview.infographicImage &&
                  imageMap[data.industryOverview.infographicImage]
                  ? imageMap[data.industryOverview.infographicImage]
                  : EnergyDetails
              }
              alt="Wind Energy Infographic"
            />
          </Col>
        </Row>

        <h2
          style={{
            // marginTop: data.industryOverview.sections2?.subTitle2 ? 40 : -10,
          }}
          className="eid-section-title"
        >
          {data.workforceChallenges.title}
        </h2>
        <Row className="eid-workforce-challenges-row" gutter={[32, 10]}>
          <Col xs={24} md={8} className="eid-workforce-challenges-col-left">
            <div className="eid-workforce-challenges-subtitle">
              {data.workforceChallenges.subtitle}
            </div>
            <div className="eid-workforce-challenges-lead">
              {data.workforceChallenges.lead}
            </div>
          </Col>
          <Col xs={24} md={16} className="eid-workforce-challenges-col-right">
            {data?.workforceChallenges?.challengesTitle && <div className="eid-workforce-challenges-list-title">
              {data?.workforceChallenges?.challengesTitle}
            </div>}
            <ul className="eid-workforce-challenges-list">
              {data.workforceChallenges.challenges.map(
                (c: string, idx: number) => (
                  <li key={idx}><div dangerouslySetInnerHTML={{ __html: c }}></div></li>
                )
              )}
              {data.workforceChallenges.dataPoints.map(
                (c: string, idx: number) => (
                  <li key={data.workforceChallenges.challenges.length + idx}>
                    {c}
                  </li>
                )
              )}
            </ul>
            {data.workforceChallenges.details && <div className="eid-workforce-challenges-desc" style={{ marginTop: 10 }}>
              {data.workforceChallenges.details}
            </div>}
          </Col>
        </Row>
        <Row
          className="eid-workforce-challenges-btn-row"
          gutter={[24, 16]}
          style={{
            marginTop: data.workforceChallenges.buttons ? 32 : 10,
            marginBottom: data.workforceChallenges.buttons ? 30 : 0,
          }}
        >
          {data.workforceChallenges.buttons &&
            data.workforceChallenges.buttons.map((btn: any, idx: number) => (
              <Col xs={24} md={12} key={idx}>
                <Button
                  htmlType="button"
                  onClick={() => {
                    btn?.think ? appendUrl(btn.link) : navigate(btn?.link);
                  }}
                  className={'common_button green_border_common_btn ' + (
                    btn.type === "filled"
                      ? " common_fill_button "
                      : "")
                  }
                  style={{ width: "100%" }}
                >
                  {btn.label}
                </Button>
              </Col>
            ))}
        </Row>

        {data.workforceChallenges.infographicImage1 != "" &&
          (industryDataMap[id] != 3 || industryDataMap[id] != 10) ? (
          <img
            className="eid-hero-img"
            src={imageMap[data.workforceChallenges.infographicImage1]}
            alt="Onshore Wind"
          />
        ) : (
            <iframe style={{ width: "100%", minHeight: 600, border: "none" }} allow="local-network-access; geolocation" title="Education and Training Database" src="https://www.arcgis.com/apps/mapviewer/index.html?configurableview=true&webmap=1c69fb70ab4b4c0cb95ffa5a8cc3282c&theme=light&legend=true&information=true&share=true&scroll=false&scale=36978595.474472&extent=-15401173.443972262,1255686.6356280819,-5362851.393339304,8221851.645424053,102100" ></iframe>
        )}

        <h2 style={{ marginTop: 20 }} className="eid-section-title">
          {data.CriticalJobs.title}
        </h2>
        <Row className="eid-jobs-header-row" gutter={[32, 16]}>
          <Col xs={24} md={8} className="eid-jobs-header-col-left">
            <div className="eid-jobs-header-subtitle">
              {data.CriticalJobs.subTitle}
            </div>
          </Col>
          <Col xs={24} md={16} className="eid-jobs-header-col-right">
            <div className="eid-jobs-header-desc">
              {data.CriticalJobs.details}
            </div>
          </Col>
        </Row>




        <div className="eid-jobs-list">
          {careerListData &&
            careerListData?.data &&
            Array.isArray(careerListData?.data?.data) &&
            careerListData?.data?.data?.length > 0 ? (
            careerListData?.data?.data?.map((job: any, idx: number) => (
              <Card
                className="career-card-row"
                key={job.id}
                // bordered={false}
                variant="borderless"
                styles={{body:{padding: "24px"}}}
                // bodyStyle={{ padding: "24px" }}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // console.log("item", job.id);
                  navigate(`/careers/details/${job.id}`);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    // alignItems: "center
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 22,
                        fontWeight: 700,
                        marginBottom: 4,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <h2
                        className="career-card-title"
                        style={{
                          whiteSpace: "wrap",
                          fontSize: 24,
                          color: "#000",
                          fontWeight: 600,
                        }}
                      >
                        {job.name}
                      </h2>
                      <div
                        style={{ placeSelf: "start" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Tooltip
                          placement="top"
                          title={
                            job.is_saved
                              ? "Remove from Saved List"
                              : "Add to Saved List"
                          }
                          className="examTooltip-mobile"
                        >
                          <Button
                            className="common_button rounded green-btn save-button"
                            icon={
                              job.is_saved ? (
                                <SVGIcon
                                  icon="Save"
                                  width={30}
                                  color={"#169C16"}
                                />
                              ) : (
                                <SVGIcon
                                  icon="SavedFilled"
                                  width={30}
                                  color={"#169C16"}
                                />
                              )
                            }
                            onClick={() =>
                              SaveAndRemoveFromJobListProcess(
                                job.id,
                                job.is_saved ? 0 : 1
                              )
                            }
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <Link
                      to="#"
                      style={{
                        color: "#0091D0",
                        fontSize: 16,
                        marginBottom: 8,
                        display: "inline-block",
                      }}
                      onClick={(e) => e.preventDefault()}
                    >
                      {job.categories && job.categories.length > 0
                        ? job.categories
                          .map((cat: any) => cat.category?.name)
                          .filter(Boolean)
                          .join(", ")
                        : "-"}
                    </Link>

                    <div
                      style={{
                        color: "#555",
                        fontSize: 15,
                        marginTop: 8,
                        maxWidth: "95%",
                      }}
                    >
                      {(() => {
                        const desc = job.description
                          ? stripHtml(job.description)
                          : "";
                        if (
                          typeof window !== "undefined" &&
                          window.innerWidth <= 767
                        ) {
                          return desc.length > 100
                            ? desc.slice(0, 100) + "..."
                            : desc;
                        } else {
                          return desc.length > 200
                            ? desc.slice(0, 200) + "..."
                            : desc;
                        }
                      })()}
                    </div>
                    <div
                      className="card-price"
                      style={{
                        fontSize: 18,
                        fontWeight: 700,
                        marginTop: "4%",
                        color: "#222",
                      }}
                    >
                      {formatGlobalPrice(job.salary_start)} -{" "}
                      {formatGlobalPrice(job.salary_end)}
                      {/* {job.salary_start == null && job.salary_end == null
                                                ? "-"
                                                : `${job.salary_start != null ? job.salary_start : "-"} - ${job.salary_end != null ? job.salary_end : "-"}`} */}
                    </div>
                  </div>

                  <div
                    className="tooltip-button"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignSelf: "center",
                      minWidth: 180,
                      gap: 12,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="examTooltip">
                      <Tooltip
                        placement="top"
                        title={
                          job.is_saved
                            ? "Remove from Saved List"
                            : "Add to Saved List"
                        }
                      >
                        <Button
                          className={
                            "common_button rounded green-btn save-button"
                          }
                          icon={
                            !job?.is_saved ? (
                              <SVGIcon
                                icon="Save"
                                width={30}
                                color={"#169C16"}
                              />
                            ) : (
                              <SVGIcon
                                icon="SavedFilled"
                                width={30}
                                color={"#169C16"}
                              />
                            )
                          }
                          onClick={() =>
                            SaveAndRemoveFromJobListProcess(
                              job.id,
                              job.is_saved ? 0 : 1
                            )
                          }
                        />
                      </Tooltip>
                    </div>
                    <div
                      style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: "#222",
                        textAlign: "right",
                      }}
                    >
                      {formatGlobalPrice(job.salary_start)} -{" "}
                      {formatGlobalPrice(job.salary_end)}
                    </div>
                  </div>
                </div>
              </Card>
            ))
          ) : loading ? (
            <div>Loading careers...</div>
          ) : (
            <></>
          )}
        </div>

        {data?.CriticalJobs?.button && <button
          onClick={() => {
            data?.CriticalJobs?.button?.think ? appendUrl(data?.CriticalJobs?.button?.link) : navigate(data?.CriticalJobs?.button?.link);
          }}
          className={'eid-skills-btn '}
        >
          {data?.CriticalJobs?.button?.label}
        </button>}

        <h2 style={{ marginTop: 40 }} className="eid-section-title eid-skill-title">
          {data.skillsAndCertifications.title}
        </h2>
        <Row className="eid-skills-header-row" gutter={[32, 16]}>
          <Col xs={24} md={8} className="eid-skills-header-col-left">
            <div className="eid-skills-header-subtitle">
              {data.skillsAndCertifications.subTitle}
            </div>
          </Col>
          <Col xs={24} md={16} className="eid-skills-header-col-right">
            <div className="eid-skills-header-desc">
              {data.skillsAndCertifications.details}
            </div>
          </Col>
        </Row>

        <div className="eid-skills-card">
          <Row gutter={[24, 0]}>
            <Col xs={24} md={12}>
              <div className="eid-skills-card-title">{data.skillsAndCertifications.keyskillTitle}</div>
              <ul className="eid-skills-list">
                {data.skillsAndCertifications.keySkills.map(
                  (skill: string, idx: number) => (
                    <li key={idx}>{skill}</li>
                  )
                )}
              </ul>
            </Col>

            <Col xs={24} md={12}>
              <div className="eid-skills-card-title">{data.skillsAndCertifications.certificationsTitle}</div>
              <ul className="eid-skills-list">
                {data.skillsAndCertifications.certifications.map(
                  (cert: string, idx: number) => (
                    <li key={idx}>{cert}</li>
                  )
                )}
              </ul>
            </Col>
          </Row>
        </div>

        {data?.buildYourSkillsBeforeYouSpecialize && <Row className="eid-skills-header-row" gutter={[32, 16]}>
          <Col xs={24} md={8} className="eid-skills-header-col-left">
            <div className="eid-skills-header-subtitle">
              {data?.buildYourSkillsBeforeYouSpecialize?.title}
            </div>
          </Col>
          <Col xs={24} md={16} className="eid-skills-header-col-right">
            <div className="eid-skills-header-desc">
              {
                data?.buildYourSkillsBeforeYouSpecialize?.description?.map((item: any) =>
                  <p dangerouslySetInnerHTML={{ __html: item }}></p>
                )}
            </div>
          </Col>
        </Row>
        }


        {data?.findTrainingbuttons && <button
          onClick={() => {
            data?.findTrainingbuttons?.think ? appendUrl(data?.findTrainingbuttons?.link) : navigate(data?.findTrainingbuttons?.link);
          }}
          className={'eid-skills-btn '}
        >
          {data?.findTrainingbuttons?.label}
        </button>}

      </div>
    </div>
  );
};

export default EnergyIndustriesDetails;
